module.exports = __webpack_public_path__ + "img/logo_bottom.56187858.png";